import type { ConfigResponse } from "@deskpro-product/messenger-api-schemas/messenger/api/conversation/query";
import type { UrlCacheableConfig } from "@deskpro-product/messenger-api-schemas/messenger/config";
import getHost from "./getHost";
import { getDecodedMessengerToken } from "./config";

export default async function getConfigClient({
  tenantId,
  messengerId,
  platform = "WEB",
  host,
  messengerToken,
}: {
  tenantId: string;
  messengerId: string;
  platform?: NonNullable<UrlCacheableConfig["platform"]>;
  host?: string;
  messengerToken: string;
}): Promise<ConfigResponse> {
  const revId = getDecodedMessengerToken(messengerToken)?.dpRevId;
  const endpoint = revId ? `config/${revId}` : "config";
  const parentHost = getHost(platform);
  const headers: Record<string, string> = {};
  headers["X-Deskpro-Client"] = host || parentHost || platform;
  headers["X-Deskpro-Token"] = messengerToken;

  const origin = import.meta.env.VITE_MESSENGER_API_ORIGIN ?? window.location.origin;
  const path = import.meta.env.VITE_MESSENGER_API_PATH ?? "";
  const url = `${origin}${path}/${tenantId}/messenger/${messengerId}/${endpoint}`;

  const response = await fetch(url, {
    headers,
  });
  if (response.status !== 200) {
    throw new Error(await response.text());
  }
  const data = await response.json();
  return data;
}
